import React from 'react';
import { Link } from 'react-router-dom';
import innomedLogo from '../../src/img/Innomedlogo-400x115_2.png';

const links = [
  {
    to: '68603693-dfca-4b2a-afc2-6b316082ab11',
    label: 'м. Вінниця вул. Магістратська, 158'
  },
  {
    to: 'a20dff87-e275-4af4-815d-6749350cf5f4',
    label: 'м. Вінниця вул. Стрілецька, 7'
  },
  {
    to: 'f88ab14c-7506-4cc4-9ce1-5a9d6d69ab5f',
    label: 'м. Вінниця Хмельницьке шосе, 96г'
  },
  {
    to: '88330ec6-307f-4958-a09b-42fe080012ae',
    label: 'м. Хмельницький вул. Проскурівського підпілля, 88'
  },
  {
    to: '1fd7ce1a-c1cf-4101-a385-bcdd32710057',
    label: 'м. Вінниця вул. Стрілецька, 7-В'
  }
];

const InnomedPage = () => {
  return (
    <div className="page__inner">
      <div className="innomed">
        <div className="innomed__container">
          <div className="innomed__header">
            <img src={innomedLogo} alt="innomed" />
          </div>
          <div className="innomed__text">
            <p className="innomed__textFirstRow">Будь ласка, оцініть свій візит!</p>
            <p>Виберіть локацію обслуговування 👇</p>
          </div>
          <div className="innomed__buttons-containers">
            {links.map((item, index) => {
              return (
                <Link key={index} to={`/device/vote/${item.to}`}>
                  <button className="innomed__button">{item.label}</button>
                </Link>
              );
            })}
          </div>
          <div className="innomed__footer">
            <p style={{ color: '#42423e' }}>
              Розроблено в &nbsp;
              <a href="https://liketo.me/" target="_blank" rel="noreferrer">
                liketo.me
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InnomedPage;
